































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import BaseVue from "@/core/BaseVue";
import { Route } from "vue-router";
import BudgetExpense from "@/models/porposal/budgetExpense.model";
import BudgetItem from "../../../../models/porposal/budgetItem.model";
@Component
export default class BudgetSubItemBase extends BaseVue {
  protected id: number | null = null;
  protected budgetItemId: number | null = null;
  protected loading = false;
  protected repository!: BaseRepository<BudgetExpense>;
  protected repositoryBudgetItem!: BaseRepository<BudgetItem>;
  protected name: any = "";
  protected secondName: any = "";
  protected model: BudgetExpense | any = null;
  protected modelBudgetItem: BudgetItem | any = null;

  created() {
    this.id = Number.parseInt(this.$route.params.budgetExpenseId);
    this.budgetItemId = Number.parseInt(this.$route.params.budgetItemId);
    if (this.hasParent && this.model == null) {
      this.repository = new BaseRepository<BudgetExpense>("BudgetExpense");
      this.repositoryBudgetItem = new BaseRepository<BudgetItem>("BudgetItem");
      this.getData();
    }
  }

  @Watch("model")
  onModelChange() {
    if (this.model)
      this.name = this.hasParent && this.model ? this.model.name : "---";
  }
  @Watch("modelBudgetItem")
  onModelBudgetItemChange() {
    if (this.modelBudgetItem)
      this.secondName =
        this.hasParent && this.modelBudgetItem
          ? this.modelBudgetItem.name
          : "---";
  }
  goToList() {
    this.$router.push("/budget-expense");
  }
  goToSecondList() {
    this.$router.push(`/budget-expense/${this.id}/budget-item`);
  }
  protected async getData() {
    try {
      if (this.id) {
        this.model = await this.repository.getById(this.id);
        this.modelBudgetItem = await this.repositoryBudgetItem.getById(
          this.budgetItemId as any
        );
      }
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
    }
  }
  get hasParent() {
    return (
      !!this.$route.params.budgetExpenseId && !!this.$route.params.budgetItemId
    );
  }
}
